import script from "./OperatorApplicationNews.vue?vue&type=script&lang=ts&setup=true"
export * from "./OperatorApplicationNews.vue?vue&type=script&lang=ts&setup=true"

import "./OperatorApplicationNews.vue?vue&type=style&index=0&id=3d7e9b1b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d7e9b1b"]])

export default __exports__